import { Component, OnInit, PLATFORM_ID, Inject, Renderer2, ViewChild, CUSTOM_ELEMENTS_SCHEMA, NgZone, afterNextRender } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, NavigationStart, NavigationCancel, NavigationError } from '@angular/router';
import { CommonModule, Location, isPlatformBrowser, isPlatformServer, DOCUMENT } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { app_web_view_list } from './const-variables';
import { ReferralCodeService } from '../app/services/ReferralCode.service';
import { RouterOutlet } from '@angular/router';
import * as globalConstant from './global_constant';
import { HeaderComponent } from './components/header/header.component';
import { VeboModalsComponent } from './components/vebo-modals/vebo-modals.component';
import { SpurToasterComponent } from './components/spur-toaster/spur-toaster.component';
import { FooterComponent } from './components/footer/footer.component';
import { CanonicalService } from './services/canonical.service';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { PageSectionService } from './services/PageSection.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { InfluencerService } from './services/influencer.service';
import { CoupanService } from './services/coupan.service';
import { ToastrService } from './services/toastr.service';
import { NgxIntlTelInputModule, SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input-gg';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { filter, Subscription } from 'rxjs';
import { KlaviyoService } from 'src/app/services/klaviyo.service';
import { v4 as uuidv4 } from 'uuid';
import { MainService } from './main.service';
import { installGoogleMapsBootstrap, preloadGoogleMapsLibraries } from './services/google-maps.service';
import { DraftPreviewSeoService } from './services/draft-preview-seo.service';
import { NoIndexSeoService } from './services/noindex-seo.service';


declare var $: any;
declare var pintrk: any;
declare var document: any;

@Component({
	selector: 'app-root',
	imports: [
		RouterOutlet,
		CommonModule,
		HeaderComponent,
		VeboModalsComponent,
		SpurToasterComponent,
		FooterComponent,
		NgxIntlTelInputModule,
		ModalModule,
		ReactiveFormsModule
	],
	templateUrl: './app.html',
	styleUrl: './app.css',
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class App {
	// protected readonly title = signal('spurnew');
	title = 'Spur Experiences';
	isBrowser: boolean;
	isServer: boolean;
	segment1: string = '';
	app_web_view_list = app_web_view_list;
	currenturl = '';
	fbclid: string = '';
	utm_source: any = '';
	utm_medium: any = '';
	utm_campaign: any = '';
	isCookies: any = true
	isHomePage: boolean = false;
	utm_parameters: any = {};
	utm_term: any = '';
	utm_content: any = '';
	isLive: any = globalConstant?.IS_LIVE;
	siteUrl: String = globalConstant?.WEBSITE_URL;
	displayAcceptCookies: boolean = false;
	influencerName: string = '';
	visitorId: string | null = null;
	authUser: any;
	@ViewChild('agreeTermsModal', { static: false }) public agreeTermsModal: ModalDirective;
	/** False on SSR + first client paint (hydration-safe); true after browser mounts modals. */
	clientModalsReady = false;
	blockUI: boolean = false;
	influencerTerms: any = [];
	safeHtml: SafeHtml;
	tokenKey: any;

	@ViewChild('signupModal', { static: false }) public signupModal: ModalDirective;
	signUpForm: FormGroup;
	email_space_error = false;
	submitted: boolean = false;
	invalid_email: any = false;
	selectedCountry: string = 'us';

	separateDialCode = true;
	SearchCountryField = SearchCountryField;
	CountryISO = CountryISO;
	preferredCountries: CountryISO[] = [CountryISO.UnitedStates];

	@ViewChild('coupanModal', { static: false }) public coupanModal: ModalDirective;
	coupanData: any;
	copyMessage = '';
	showCopyMessage = false;
	coupanEndDate: any;
	routeUrl: string = '';
	openSignupPopupSubscription: Subscription;
	offerVisible: any;
	baseUrl = '';
	/** Covers white gap while the lazy exp-detail chunk loads. */
	showExpNavLoader = false;
	showNavProgress = false;
	private skipNavProgress = true;
	readonly expNavLoaderLines: string[] = [
		'Finding your next unforgettable experience…',
		'Gathering photos, details & availability…',
		'Checking dates and local favorites…',
		'Almost there — packing the good stuff…',
	];
	expNavLoaderLineIndex = 0;
	expNavLoaderLine = this.expNavLoaderLines[0];
	private expNavLineTimer: ReturnType<typeof setInterval> | null = null;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private location: Location,
		private referralCodeService: ReferralCodeService,
		private metaService: Meta,
		public renderer: Renderer2,
		private canonicalService: CanonicalService,
		private draftPreviewSeo: DraftPreviewSeoService,
		public pageSectionService: PageSectionService,
		private sanitizer: DomSanitizer,
		public influencerService: InfluencerService,
		public coupanService: CoupanService,
		private noIndexSeo: NoIndexSeoService,
		public toastr: ToastrService,
		public klaviyoService: KlaviyoService,
		private mainService: MainService,
		private formBuilder: FormBuilder,
		@Inject(DOCUMENT) document1: any,
		@Inject(PLATFORM_ID) platformId: Object,
		private ngZone: NgZone
	) {

		this.isBrowser = isPlatformBrowser(platformId);
		this.isServer = isPlatformServer(platformId);

		afterNextRender(() => {
			this.clientModalsReady = true;
		});

		this.router.events
			.pipe(filter(event => event instanceof NavigationStart))
			.subscribe(() => {
				this.mainService.clearSchema();
				// Keep placeholder nodes so paginated pages can update href (SSR-safe).
				this.canonicalService.resetPaginationLinksToStubs();
			});

		// Drop invalid legacy <meta property="description"> (SEO uses name="description").
		this.metaService.removeTag('property="description"');

		this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe((event: NavigationEnd) => {
				this.metaService.removeTag('property="description"');
				const url = event.urlAfterRedirects || event.url;
				// Utility routes: /login, /cart, /registration/*, /knot
				this.noIndexSeo.applyForUrl(url);
				// Admin draft preview (?preview_token=) — noindex for gifts, blogs, and any page.
				this.draftPreviewSeo.applyIfPreview(url);
				// After paginated components finish constructor/ngOnInit updates, drop leftover stubs.
				queueMicrotask(() => {
					this.metaService.removeTag('property="description"');
					this.canonicalService.clearStubPaginationLinks();
					this.noIndexSeo.applyForUrl(url);
					this.draftPreviewSeo.applyIfPreview(url);
				});
			});

		if (this.isBrowser) {
			this.hideBootLoader();
			// Server HTML stays visible. The full-screen loader is only for a client
			// shell that has no page yet. Clicks use the thin bar.
			if (this.isExpDetailUrl(window.location.pathname) && !this.hasSsrRouteContent()) {
				this.openExpNavLoader();
			}
			this.router.events.subscribe((event) => {
				if (event instanceof NavigationStart) {
					if (!this.skipNavProgress) {
						this.showNavProgress = true;
						this.closeExpNavLoader();
					}
				} else if (
					event instanceof NavigationEnd ||
					event instanceof NavigationCancel ||
					event instanceof NavigationError
				) {
					this.skipNavProgress = false;
					this.showNavProgress = false;
					requestAnimationFrame(() => this.closeExpNavLoader());
				}
			});
		}

		if (this.isBrowser) {
			this.baseUrl = window.location.origin;
			// importLibrary must exist before <google-map> inits. The deferred
			// script tag used to leave google.maps without that function.
			installGoogleMapsBootstrap();
			let isBoat = this.isSitePerformanceBoat();
			if (!isBoat) {
				this.scheduleThirdPartyScripts();
			}
			this.initializeAuthData();
		}

		this.openSignupPopupSubscription = this.referralCodeService.openSignupPopup$.subscribe(data => {
			if (data === true) {
				this.signupModal?.show();
			} else if (data === false) {
				this.signupModal?.hide();
			}
		});

		this.activatedRoute?.queryParams.subscribe(params => {
			this.utm_parameters = params;
			if (params['utm_source'] || params['fbclid'] && this.isBrowser) {
				if (params['utm_source']) {
					if (params['utm_campaign'] === 'influencer') {
						this.influencerName = params['utm_source'];
						sessionStorage.setItem('influencerData', this.influencerName);
						this.getDeviceId();
					} else {
						this.utm_source = params['utm_source'];
					}
				} else if (params['fbclid']) {
					this.fbclid = params['fbclid'];
					this.utm_source = 'facebook';
				} else if (document.referrer == 'https://l.facebook.com/') {
					this.fbclid = 'https://l.facebook.com/';
					this.utm_source = 'facebook';
				}

				if (params['utm_medium']) {
					this.utm_medium = params['utm_medium'];
				} else {
					this.utm_medium = '';
				} if (params['utm_campaign']) {
					this.utm_campaign = params['utm_campaign'];
				} else {
					this.utm_campaign = '';
				} if (params['utm_term']) {
					this.utm_term = params['utm_term']
				} else {
					this.utm_term = '';
				} if (params['utm_content']) {
					this.utm_content = params['utm_content'];
				} else {
					this.utm_content = '';
				}

				let utm_campaign_check
				let utm_source_check

				if (localStorage.getItem('referal_code_parameters')) {
					let logData = JSON.parse(localStorage.getItem('referal_code_parameters'))
					utm_source_check = logData?.utm_source
					utm_campaign_check = logData?.utm_campaign
				}
				if (utm_campaign_check != this.utm_campaign || this.utm_source != utm_source_check) {

					let requestBody = { 'utm_source': this.utm_source, 'fbclid': this.fbclid, 'utm_medium': this.utm_medium, 'utm_campaign': this.utm_campaign, 'utm_term': this.utm_term, 'utm_content': this.utm_content };
					localStorage.setItem('referal_code_parameters', JSON.stringify(requestBody));

					this.referralCodeService.saveReferralSource(requestBody).subscribe();
					utm_campaign_check = this.utm_campaign
					utm_source_check = this.utm_source
				}
				// this.addMetaTags();
			}
		});

		const currentPath = this.location.path();
		const current = currentPath.split('?')[0];
		this.routeUrl = current;
		if (current) {
			const segments = current.split('/');
			if (segments[1]) {
				this.currenturl = segments[1];
			}
		}

		if (currentPath === '/' || currentPath == '') {
			this.isHomePage = true;
		}
	}

	async getDeviceId(): Promise<string | null> {
		if (this.isBrowser) {
			if (this.visitorId) {
				return this.visitorId;
			}

			let deviceId = localStorage.getItem('device-id');

			if (!deviceId) {
				deviceId = uuidv4();
				localStorage.setItem('device-id', deviceId);
			}

			this.visitorId = deviceId;

			if (this.influencerName) {
				const hasTrackedKey = `influencer-tracked-${this.influencerName}`;

				if (!localStorage.getItem(hasTrackedKey)) {
					const requestBody = {
						source_value: deviceId,
						source_type: 'web_device_id',
						influencer_username: this.influencerName,
					};

					this.referralCodeService
						.influencerReferralLog(requestBody)
						.subscribe(() => {
							localStorage.setItem(hasTrackedKey, 'true');
						});
				}
			}

			return deviceId;
		}
	}

	normalizeUrl(url: string): string {
		return url.endsWith('/') ? url.slice(0, -1) : url; // Remove trailing slash if present
	}

	ngOnInit() {
		this.signUpForm = this.formBuilder.group({
			user_email: ['', [Validators.required]],
			user_phone: [[], [Validators.required]],
		});

		this.router?.events.subscribe(event => {
			if (event instanceof NavigationEnd) {
				this.hideBootLoader();
				var urlObj = this.router?.url?.split('/');

				if (urlObj[1]) {
					this.segment1 = this.router?.url?.split('/')[1];
				}
				if (this.isBrowser) {
					if (((this.segment1 !== undefined && this.segment1 !== null && this.segment1 !== '') &&
						(this.segment1 == 'registry' || this.segment1 == 'experiences' ||
							this.segment1 == 'ticket-map-web-view')) || (this.routeUrl == "/ticket-map-web-view")) {
						this.displayAcceptCookies = false;
					} else {
						this.displayAcceptCookies = true;
					}
				}
				if (urlObj[1] !== "experience-provider-add") {
					if (this.isBrowser) {

						localStorage.removeItem('exp-provider-add')
					}
				}
				if (this.router?.url?.split('/')[1]) {
					if (this.router?.url?.split('/')[1]?.split('?')[0]) {
						this.currenturl = this.router?.url?.split('/')[1]?.split('?')[0];
					} else {
						this.currenturl = this.router?.url?.split('/')[1];
					}
				} else {
					this.currenturl = '';
				}
			}
		});
		const canonicalUrl = this.normalizeUrl(this.siteUrl + this.router.url);
		this.canonicalService.setCanonical(canonicalUrl);
		this.noIndexSeo.applyForUrl(this.router.url);
		this.draftPreviewSeo.applyIfPreview(this.router.url);

		if (this.isLive) {
			this.load_pinterest_script();
		}

		this.getContentHeight();
		if (this.isBrowser) {
			this.isCookies = document?.cookie.split(';')
		}
		this.checkCookie();
	}

	get user() {
		return this.signUpForm?.controls;
	}

	getAuthToken() {
		if (this.isBrowser) {
			if (localStorage.getItem('login_token')) {
				this.tokenKey = localStorage.getItem('login_token');
			} else {
				setTimeout(() => {
					if (this.routeUrl !== "/ticket-map-web-view" && this.routeUrl !== "/wedding-registry" &&
						this.routeUrl !== "/registration/wedding-couple"
					) {
						let displayCoupan = localStorage?.getItem('DisplayedCoupanOffer')
						if (localStorage.getItem('login_token')) {
							this.tokenKey = localStorage.getItem('login_token');
						}
						if (!displayCoupan && !this.tokenKey) {
							if (localStorage?.getItem('CoupanCode')) {
								let added = JSON.parse(localStorage.getItem('CoupanCode'));
								if (!added) {
									this.signupModal?.show();
								}
							} else {
								this.signupModal?.show();
							}
						}
					}
				}, 45000)
			}
		}
	}

	initializeAuthData() {
		if (this.isBrowser) {
			this.referralCodeService.authUser$.subscribe(user => {
				this.authUser = user;
				this.getAuthToken();
				if (user?.is_influencer && user?.is_influencer_agreed_terms == 0) {
					this.getInfluencerTerms();
					setTimeout(() => {
						this.agreeTermsModal?.show();
						this.blockUI = true;
					}, 1000);
				}
			});

			const storedUser = this.referralCodeService.getAuthUser();
			if (storedUser) {
				this.referralCodeService.setAuthUser(storedUser);
			}
		}
	}

	getInfluencerTerms() {
		let requestBody = { 'slug': "influencer-terms-conditions" };
		this.pageSectionService.get_page_data(requestBody).subscribe(res => {
			if (res.response == "success") {
				this.influencerTerms = res?.data;
				if (this.influencerTerms?.body) {
					this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.influencerTerms.body);
				}
			}
		});
	}

	setCookie(cname, cvalue, exdays) {
		const d = new Date();
		d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
		let expires = "expires=" + d.toUTCString();
		document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
		this.isCookies = true;

		localStorage.setItem("acceptCookies", "yes");
	}

	checkCookie() {
		let cart = this.getCookie("acceptCookies");
		if (cart != "") {
			this.isCookies = true
		} else {
			this.isCookies = false
			if (cart != "" && cart != null) {
				this.setCookie("acceptCookies", cart, 365);
			}
		}
	}

	getCookie(data) {
		if (this.isBrowser) {

			let name = data + "=";
			let ca = document.cookie.split(';');
			for (let i = 0; i < ca.length; i++) {
				let c = ca[i];
				while (c.charAt(0) == ' ') {
					c = c.substring(1);
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length);
				}
			}
			return "";
		}
	}

	private thirdPartyScriptsStarted = false;

	/** Maps, ads, and pixels still load after the first tap, scroll, or a short wait. */
	scheduleThirdPartyScripts(): void {
		if (!this.isBrowser || this.thirdPartyScriptsStarted) {
			return;
		}
		const run = () => {
			if (this.thirdPartyScriptsStarted) {
				return;
			}
			this.thirdPartyScriptsStarted = true;
			window.removeEventListener('pointerdown', run);
			window.removeEventListener('keydown', run);
			window.removeEventListener('scroll', run);
			this.ngZone.runOutsideAngular(() => {
				this.loadExternalCss(this.renderer, "https://connect.facebook.net");
				this.loadExternalCss(this.renderer, "https://maps.googleapis.com");
				this.loadExternalCss(this.renderer, "https://storage.googleapis.com");
				preloadGoogleMapsLibraries();
				this.loadJsScript(this.renderer, "https://assets.spurexperiences.com/assets/js/lazysizes.min.js", true, true);
				this.loadJsScript(this.renderer, "https://apis.google.com/js/platform.js", true, true);
				this.loadJsScript(this.renderer, "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js", true, true);
				this.loadPinterestTrackingScript();
				this.loadFacebookPixel();
				this.loadGoogleRemarketingScript();
				this.loadTikTokPixel();
				if (this.isLive) {
					this.load_pinterest_script();
				}
			});
		};
		window.addEventListener('pointerdown', run, { once: true, passive: true });
		window.addEventListener('keydown', run, { once: true });
		window.addEventListener('scroll', run, { once: true, passive: true });
		const idle = (window as Window & { requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => void }).requestIdleCallback;
		if (idle) {
			idle(() => setTimeout(run, 8000), { timeout: 8000 });
		} else {
			setTimeout(run, 10000);
		}
	}

	isSitePerformanceBoat(): boolean {
		const userAgent = window.navigator.userAgent || '';
		if (/GTmetrix|Chrome-Lighthouse|Lighthouse|PageSpeed|PTST/i.test(userAgent)) {
			return true;
		}
		return navigator.webdriver === true;
	}

	loadSnapEngageScript(): void {
		const script = this.renderer.createElement('script');
		this.renderer.setAttribute(script, 'type', 'text/javascript');
		this.renderer.setAttribute(script, 'async', '');
		this.renderer.setAttribute(script, 'defer', '');
		this.renderer.setAttribute(
			script,
			'src',
			'//storage.googleapis.com/code.snapengage.com/js/794d2fd0-e8b6-4835-90dd-f1b5bbf04614.js'
		);

		script.onload = () => {
			console.log('SnapEngage script loaded.');
			// Place your SnapEngage JS API code below
			// Example: SnapEngage.allowChatSound(true); 
		};

		script.onerror = () => {
			console.error('Failed to load the SnapEngage script.');
		};

		// Append the script to the head or body
		const firstScript = document.getElementsByTagName('script')[0];
		this.renderer.appendChild(firstScript.parentNode, script);
	}

	loadPinterestTrackingScript(): void {
		// Add the Pinterest script
		const pinterestScript = this.renderer.createElement('script');
		this.renderer.setAttribute(pinterestScript, 'type', 'text/javascript');
		pinterestScript.text = `
		  !function (e) {
			if (!window.pintrk) {
			  window.pintrk = function () {
				window.pintrk.queue.push(Array.prototype.slice.call(arguments))
			  };
			  var n = window.pintrk;
			  n.queue = [], n.version = "3.0";
			  var t = document.createElement("script");
			  t.async = !0, t.src = e;
			  var r = document.getElementsByTagName("script")[0];
			  r.parentNode.insertBefore(t, r)
			}
		  }("https://s.pinimg.com/ct/core.js");
		  pintrk('load', '2619018219672');
		`;
		this.renderer.appendChild(document.head, pinterestScript);

		// Add the noscript element
		const noscript = this.renderer.createElement('noscript');
		const img = this.renderer.createElement('img');
		this.renderer.setAttribute(img, 'src', 'https://ct.pinterest.com/v3/?tid=2619018219672&noscript=1');
		this.renderer.setAttribute(img, 'height', '1');
		this.renderer.setAttribute(img, 'width', '1');
		this.renderer.setAttribute(img, 'style', 'display:none;visibility:hidden');
		this.renderer.appendChild(noscript, img);
		this.renderer.appendChild(document.body, noscript);
	}

	loadFacebookPixel(): void {
		// Add the Facebook Pixel script
		const facebookScript = this.renderer.createElement('script');
		facebookScript.type = 'text/javascript';
		facebookScript.text = `
		  !function (f, b, e, v, n, t, s) {
			if (f.fbq) return;
			n = f.fbq = function () {
			  n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
			};
			if (!f._fbq) f._fbq = n;
			n.push = n;
			n.loaded = !0;
			n.version = '2.0';
			n.queue = [];
			t = b.createElement(e);
			t.async = !0;
			t.src = v;
			s = b.getElementsByTagName(e)[0];
			s.parentNode.insertBefore(t, s)
		  }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
		  fbq('init', '1049718878423156');
		  fbq('track', 'PageView');
		`;
		this.renderer.appendChild(document.head, facebookScript);

		// Add the noscript fallback
		const noscript = this.renderer.createElement('noscript');
		const img = this.renderer.createElement('img');
		this.renderer.setAttribute(img, 'src', 'https://www.facebook.com/tr?id=1049718878423156&ev=PageView&noscript=1');
		this.renderer.setAttribute(img, 'height', '1');
		this.renderer.setAttribute(img, 'width', '1');
		this.renderer.setAttribute(img, 'style', 'display:none;visibility:hidden');
		this.renderer.appendChild(noscript, img);
		this.renderer.appendChild(document.body, noscript);
	}

	loadGoogleRemarketingScript(): void {
		// Add the Google remarketing script
		const googleScript = this.renderer.createElement('script');
		this.renderer.setAttribute(googleScript, 'type', 'text/javascript');
		this.renderer.setAttribute(googleScript, 'src', '//www.googleadservices.com/pagead/conversion_async.js');
		this.renderer.appendChild(document.body, googleScript);

		// Add the noscript fallback
		const noscript = this.renderer.createElement('noscript');
		const div = this.renderer.createElement('div');
		this.renderer.setAttribute(div, 'style', 'display:inline;');

		const img = this.renderer.createElement('img');
		this.renderer.setAttribute(
			img,
			'src',
			'//googleads.g.doubleclick.net/pagead/viewthroughconversion/971177656/?value=0&amp;guid=ON&amp;script=0'
		);
		this.renderer.setAttribute(img, 'height', '1');
		this.renderer.setAttribute(img, 'width', '1');
		this.renderer.setAttribute(img, 'style', 'border-style:none;');

		this.renderer.appendChild(div, img);
		this.renderer.appendChild(noscript, div);
		this.renderer.appendChild(document.body, noscript);
	}

	loadTikTokPixel(): void {
		// Define TikTok pixel initialization function
		const initTikTokPixel = `
		  (function (w, d, t) {
			w.TiktokAnalyticsObject = t;
			var ttq = w[t] = w[t] || [];
			ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias",
			  "group", "enableCookie", "disableCookie"];
			ttq.setAndDefer = function (t, e) {
			  t[e] = function () {
				t.push([e].concat(Array.prototype.slice.call(arguments, 0)))
			  };
			};
			for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
			ttq.instance = function (t) {
			  for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]);
			  return e;
			};
			ttq.load = function (e, n) {
			  var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
			  ttq._i = ttq._i || {}, ttq._i[e] = [], ttq._i[e]._u = i, ttq._t = ttq._t || {}, ttq._t[e] = +new Date;
			  ttq._o = ttq._o || {}, ttq._o[e] = n || {};
			  var o = d.createElement("script");
			  o.type = "text/javascript", o.async = true, o.src = i + "?sdkid=" + e + "&lib=" + t;
			  var a = d.getElementsByTagName("script")[0];
			  a.parentNode.insertBefore(o, a);
			};
			ttq.load('CFHVP1JC77UCCRP96PU0');
			ttq.page();
		  })(window, document, 'ttq');`;

		// Create and append the script element
		const script = this.renderer.createElement('script');
		this.renderer.setAttribute(script, 'type', 'text/javascript');
		script.text = initTikTokPixel;
		this.renderer.appendChild(document.body, script);
	}

	addGTMScript(gtmId: string) {
		const script = this.renderer.createElement('script');
		script.type = 'text/javascript';
		script.async = true;
		script.text = `
			(function (w, d, s, l, i) {
				w[l] = w[l] || []; w[l].push({
				'gtm.start':
					new Date().getTime(), event: 'gtm.js'
				}); 
				var f = d.getElementsByTagName(s)[0],
					j = d.createElement(s),
					dl = l != 'dataLayer' ? '&l=' + l : '';
				j.async = true;
				j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
				f.parentNode.insertBefore(j, f);
			})(window, document, 'script', 'dataLayer', '${gtmId}');
		`;
		this.renderer.appendChild(document.head, script);


		const script2 = this.renderer.createElement('script');
		script2.type = 'text/javascript';
		script2.async = true;
		script2.src = `https://www.googletagmanager.com/gtag/js?id=${gtmId}`;
		this.renderer.appendChild(document.head, script2);

		// Add the GTAG initialization script
		const inlineScript = this.renderer.createElement('script');
		inlineScript.type = 'text/javascript';
		inlineScript.text = `
		window.dataLayer = window.dataLayer || [];
		function gtag() { dataLayer.push(arguments); }
		gtag('js', new Date());
		gtag('config', '${gtmId}');
		`;
		this.renderer.appendChild(document.head, inlineScript);

	}

	public loadClarityScript(): void {
		// Check if the script is already loaded to avoid duplicates
		if (document.getElementById('clarity-script')) {
			return;
		}

		// Create the script element
		const script = document.createElement('script');
		script.id = 'clarity-script';
		script.async = true;
		script.src = 'https://www.clarity.ms/tag/ifpvpw24xu';

		// Append the script to the document's head
		document.head.appendChild(script);

		// Initialize Clarity
		(window as any).clarity =
			(window as any).clarity ||
			function () {
				((window as any).clarity.q = (window as any).clarity.q || []).push(arguments);
			};
	}

	public loadJsScript(renderer: Renderer2, src: string, isAsync: boolean = false, isDefer: boolean = false): HTMLScriptElement {
		const script = renderer.createElement('script');
		script.type = 'text/javascript';
		script.src = src;
		if (isAsync) {
			script.async = true;
		}
		if (isDefer) {
			script.defer = true;
		}
		renderer.appendChild(document.body, script);
		return script;
	}

	public loadExternalCss(renderer: Renderer2, href: string): HTMLScriptElement {
		const link = renderer.createElement('link');
		link.rel = 'dns-prefetch';
		link.href = href;
		renderer.appendChild(document.head, link);
		return link;
	}

	addMetaTags() {
		let iosAffliatedData = JSON.stringify(this.utm_parameters);
		let appArguments = iosAffliatedData;

		let iosMetaContent = 'app-id=1123434344,affiliate-data=' + iosAffliatedData + ',app-argument=https://www.spurexperiences.com?utm_source=google';
		this.metaService.updateTag({ name: 'apple-itunes-app', content: iosMetaContent });

	}

	onResize(event) {
		this.getContentHeight();
	}

	load_pinterest_script() {
		if (!this.isBrowser) {
			return;
		}
		const pintrk = (window as unknown as { pintrk?: (...args: unknown[]) => void }).pintrk;
		if (typeof pintrk === 'function') {
			pintrk('track', 'pagevisit');
		}
	}

	getContentHeight() {
		if (this.isBrowser && typeof requestAnimationFrame !== 'undefined') {
			requestAnimationFrame(() => {
				const header = document.getElementById("header");
				const footer = document.getElementById("footer");
				const wrapper = document.getElementById("body-content-wrapper");
				if (document.documentElement && header && footer && wrapper) {
					const wndowHeight = document.documentElement.clientHeight;
					const mainHeader = header.clientHeight;
					const mainFooter = footer.clientHeight;
					wrapper.style.minHeight = wndowHeight - (mainHeader + mainFooter) + "px";
				}
			});
		}
	}

	closeCookies() {
		this.isCookies = true
	}

	inflencerAgreeTermsAndConditions() {
		let requestbody = {};
		this.influencerService.inflencerAgreeTermsAndConditions(requestbody, this.tokenKey).subscribe(res => {
			if (res?.response === 'success') {
				let authUserData = JSON.parse(localStorage.getItem('authUser'));
				authUserData.is_influencer_agreed_terms = 1;
				localStorage.setItem('authUser', JSON.stringify(authUserData));
				this.referralCodeService.setAuthUser(authUserData);
				this.authUser = authUserData;
				this.closeAgreeTermsModal();
				if (authUserData?.is_influencer && (authUserData?.has_seen_onboarding_popup == null || authUserData?.has_seen_onboarding_popup == 0)) {
					this.openInfluencerWelcomeAfterTerms();
				}
			} else {
				// error response
				this.toastr.errorToastr("Something went wrong!", 'Error!');
			}
		});
	}

	private openInfluencerWelcomeAfterTerms(): void {
		const openWelcome = () => {
			setTimeout(() => {
				this.influencerService.triggerWelcomeModal();
			}, 600);
		};

		const currentPath = this.router.url?.split('?')[0] || '';
		if (currentPath !== '/my-profile') {
			this.router.navigate(['/my-profile']).then(() => openWelcome());
		} else {
			openWelcome();
		}
	}

	closeAgreeTermsModal() {
		this.agreeTermsModal.hide();
		this.blockUI = false;
	}

	closePopup(): void {
		this.signupModal.hide();
		localStorage.setItem('DisplayedCoupanOffer', 'true');
	}

	closeThankyouPopup() {
		this.coupanModal.hide();
	}

	check_email_format(event) {
		if (event?.target?.value?.split(/\s/)?.join('') != "") {
			this.email_space_error = false;
			if (this.isEmail(event?.target?.value?.replace(/^\s+|\s+$/gm, ''))) {
				this.invalid_email = false;
			}
			else {
				this.invalid_email = true;
			}
		} else {
			if (this.submitted) {
				this.email_space_error = true;
			}
			this.invalid_email = false;
		}
	}

	isEmail(email) {
		var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
		return regex.test(email);
	}

	onCountryChange(event: any) {
		this.selectedCountry = event?.iso2;
	}

	formatPhoneNumber(event: any): void {
		if (this.selectedCountry === 'us') {
			const input = event?.target?.value.replace(/\D/g, '');
			if (input.length > 0) {
				let formatted = '';
				if (input.length <= 3) {
					formatted = `(${input}`;
				} else if (input.length <= 6) {
					formatted = `(${input.slice(0, 3)}) ${input.slice(3)}`;
				} else {
					formatted = `(${input.slice(0, 3)}) ${input.slice(3, 6)}-${input.slice(6, 10)}`;
				}
				this.signUpForm.controls['user_phone'].setValue(formatted, { emitEvent: false });
			}
		}
	}

	onSubmit(): void {
		this.submitted = true;
		if (this.signUpForm.invalid || this.signUpForm?.get('user_email')?.value?.split(/\s/)?.join('') == "" || this.invalid_email) {
			if (this.signUpForm?.get('user_email')?.value?.split(/\s/)?.join('') == "") {
				this.email_space_error = true;
			}
			else {
				this.email_space_error = false;
			}
			return;
		} else {
			this.email_space_error = false;
		}
		let requestBody = {
			'email': this.signUpForm.get('user_email').value.replace(/^\s+|\s+$/gm, ''),
			'phone_json': this.signUpForm.get('user_phone').value,
		}

		let email = this.signUpForm.get('user_email').value.replace(/^\s+|\s+$/gm, '');
		if (email && email != '') {
			if (this.baseUrl && (this.baseUrl == 'spurexperiences.com' || this.baseUrl == 'spurexperiences.com/'
				|| this.baseUrl == 'https://spurexperiences.com/' || this.baseUrl == 'https://spurexperiences.com')) {
				this.klaviyoService.identifyUser(email);
			}
		}
		this.coupanService.saveVisitorData(requestBody).subscribe(res => {
			if (res?.response == "success") {
				if (res?.data) {
					this.coupanData = res?.data;
					this.coupanEndDate = this.formatDate(this.coupanData?.end_date)
					if (this.isBrowser) {
						localStorage.setItem('CoupanCode', JSON.stringify(this.coupanData));
						localStorage.setItem('DisplayedCoupanOffer', 'true');
						this.referralCodeService.displayGiftCodePopup.next(false);
					}
					this.closePopup();
					this.coupanModal?.show();
				}
			} else {
				this.submitted = false;
				this.toastr.errorToastr(res.message, 'Error!');
			}
		});
	}

	async copyCouponCode(): Promise<void> {
		try {
			if (this.coupanData?.coupon_number) {
				await navigator.clipboard.writeText(this.coupanData.coupon_number);
				this.showCopySuccess();
			}
		} catch (err) {
			// Fallback for older browsers or when clipboard API fails
			this.fallbackCopyTextToClipboard(this.coupanData?.coupon_number || '');
		}
	}

	fallbackCopyTextToClipboard(text: string): void {
		const textArea = document.createElement('textarea');
		textArea.value = text;
		textArea.style.top = '0';
		textArea.style.left = '0';
		textArea.style.position = 'fixed';

		document.body.appendChild(textArea);
		textArea.focus();
		textArea.select();

		try {
			const successful = document.execCommand('copy');
			if (successful) {
				this.showCopySuccess();
			} else {
				this.showCopyError();
			}
		} catch (err) {
			this.showCopyError();
		}

		document.body.removeChild(textArea);
	}

	showCopySuccess() {
		this.copyMessage = 'Coupon code copied!';
		this.showCopyMessage = true;
		setTimeout(() => {
			this.showCopyMessage = false;
		}, 4000);
	}

	showCopyError() {
		this.copyMessage = 'Failed to copy coupon code';
		this.showCopyMessage = true;
		setTimeout(() => {
			this.showCopyMessage = false;
		}, 2000);
	}

	parseDateToObject(dateStr) {
		let date = new Date(dateStr)
		return new Date(date.toISOString().slice(0, -1));
	}

	formatDate(str) {
		const date = this.parseDateToObject(str);

		const day = date.getDate();
		const month = date.toLocaleString('default', { month: 'long' });
		const year = date.getFullYear();

		const ordinalSuffix = (day: number) => {
			if (day > 3 && day < 21) return 'th';
			switch (day % 10) {
				case 1: return 'st';
				case 2: return 'nd';
				case 3: return 'rd';
				default: return 'th';
			}
		};

		return `${month} ${day}${ordinalSuffix(day)}, ${year}`;
	}

	private isExpDetailUrl(url: string): boolean {
		const path = (url || '').split('?')[0];
		return (
			/^\/experiences\/[^\/]+\/?$/.test(path) ||
			/^\/cart\/?$/.test(path)
		);
	}

	/** True when SSR already delivered route markup inside app-root. */
	private hasSsrRouteContent(): boolean {
		if (!this.isBrowser || typeof document === 'undefined') {
			return false;
		}
		const root = document.querySelector('app-root');
		if (!root || root.children.length === 0) {
			return false;
		}
		return !!(
			root.querySelector(
				'app-exp-detail-new, .Details_Page, .newExp_content, app-cart, app-location-region'
			) || root.getAttribute('ng-server-context') === 'ssr'
		);
	}

	private openExpNavLoader(): void {
		if (this.showExpNavLoader) {
			return;
		}
		this.showExpNavLoader = true;
		this.expNavLoaderLineIndex = 0;
		this.expNavLoaderLine = this.expNavLoaderLines[0];
		if (this.expNavLineTimer) {
			return;
		}
		this.expNavLineTimer = setInterval(() => {
			this.expNavLoaderLineIndex =
				(this.expNavLoaderLineIndex + 1) % this.expNavLoaderLines.length;
			this.expNavLoaderLine = this.expNavLoaderLines[this.expNavLoaderLineIndex];
		}, 2200);
	}

	private closeExpNavLoader(): void {
		this.showExpNavLoader = false;
		if (this.expNavLineTimer) {
			clearInterval(this.expNavLineTimer);
			this.expNavLineTimer = null;
		}
	}

	private hideBootLoader(): void {
		if (!this.isBrowser) {
			return;
		}
		const boot = document.getElementById('spur-boot-loader');
		if (boot) {
			boot.setAttribute('hidden', '');
			boot.setAttribute('aria-hidden', 'true');
		}
	}
}
